module.exports = __webpack_public_path__ + "img/img_77.aac06c8c.png";